const items = [
  "Gros œuvre",
  "Parpaing · Biobrique · Béton",
  "Rénovation",
  "Brique & parement",
  "Carrelage",
  "Terrasses",
  "Maçonnerie traditionnelle",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <section className="border-y border-white/10 py-6 overflow-hidden bg-[#0A0A0A]" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-display italic font-light text-2xl md:text-3xl text-zinc-500 px-8">{item}</span>
            <span className="text-[#C4A484] text-sm">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
